import script from "./reportSmsNotification.vue?vue&type=script&setup=true&lang=js"
export * from "./reportSmsNotification.vue?vue&type=script&setup=true&lang=js"

import "./reportSmsNotification.vue?vue&type=style&index=0&id=3308c3bc&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3308c3bc"]])

export default __exports__